<div
  class="irembo-id-input"
  [ngClass]="formControl?.invalid ? 'errorfield' : statusClass">
  <input
    #citizenId
    [formControl]="customFormControl"
    [readOnly]="isReadonly"
    type="text"
    class="form-control"
    [id]="id"
    [placeholder]="placeholder" />
  <span class="thumb-icon">
    <span class="icon-success">
      <i class="fa fa-thumbs-up"></i>
    </span>
    <span class="icon-danger">
      <i class="fa fa-thumbs-down"></i>
    </span>
    <output class="spinner-border text-primary spinner-border-sm">
      <span class="visually-hidden">Loading...</span>
    </output>
  </span>
  <div class="msg"></div>
</div>
